export class ApiError extends Error {
  constructor(message: string) {
    super(message);

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ApiError);
    }

    this.name = "ApiError";
  }

  getObject(): Error {
    return {
      name: this.name,
      message: this.message,
    };
  }
}
